import { render, staticRenderFns } from "./NormalBtn.vue?vue&type=template&id=c94aed5a&scoped=true&"
import script from "./NormalBtn.vue?vue&type=script&lang=js&"
export * from "./NormalBtn.vue?vue&type=script&lang=js&"
import style0 from "./NormalBtn.vue?vue&type=style&index=0&id=c94aed5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94aed5a",
  null
  
)

export default component.exports